import { render, staticRenderFns } from "./SideDetailListCard.vue?vue&type=template&id=4ab3ba43&"
import script from "./SideDetailListCard.vue?vue&type=script&lang=js&"
export * from "./SideDetailListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports